import { render, staticRenderFns } from "./ConvertToCurrencyComponent.vue?vue&type=template&id=70dc7cbc&"
import script from "./ConvertToCurrencyComponent.vue?vue&type=script&lang=js&"
export * from "./ConvertToCurrencyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports